import { render, staticRenderFns } from "./SelectActiveIngredientID.vue?vue&type=template&id=6b925804&"
import script from "./SelectActiveIngredientID.vue?vue&type=script&lang=js&"
export * from "./SelectActiveIngredientID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports